import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

interface Props {
  readonly totalSteps: number;
  readonly currentStep: number;
}

export const AnnouncementDotIndicator: React.FC<Props> = (props: Props): React.ReactElement => {
  const { totalSteps, currentStep } = props;

  return (
    <Box role="tablist" sx={styles.container}>
      {Array.from(
        { length: totalSteps },
        (_: unknown, index: number): React.ReactElement => (
          <Box
            key={index}
            role="tab"
            aria-selected={index === currentStep}
            aria-label={`Step ${index + 1} of ${totalSteps}`}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: index === currentStep ? 'primary.main' : 'custom.LightGray',
              transition: 'background-color 300ms ease',
            }}
          />
        ),
      )}
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: 1,
    my: 3,
  },
};
